import { PessoaFisica } from './../pessoa/pessoa.model';
import { UsuarioSistemaGrupo } from '../usuario-sistema-grupo/usuario-sistema-grupo.model';

export class UsuarioSistema extends PessoaFisica {
    Login: String;
    Senha: string;
    SuperUsuario: string;
    Grupos: UsuarioSistemaGrupo[] = [];
}



// WEBPACK FOOTER //
// ./src/app/usuario-sistema/usuario-sistema.model.ts